<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/school-desktop-banners/arni-school-of-law.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-law.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-law.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#hod-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">HOD's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!-- <a href="#testimonials"
                class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Law</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-600 text-justify">The Arni school of law plays a crucial role in shaping the future of
                legal professionals with a focus on providing a comprehensive understanding of legal principles, system
                and practices. The department aims to equip students with necessary skills to excel in the field of
                law.</p>
            <p class="text-gray-600 text-justify">The school of Law is the guiding light of legal education whose
                primary goal is to groom the future legal
                professionals who must have the sound knowledge of law, justice and ethics. At the core of our program
                are the fundamentals of legal principles, theories and methodologies, which form the structural basis
                upon which students can build their legal career. By way of relevant course work and mock trials,
                students acquire the necessary skills of critical thinking, logical reasoning and advocacy that should
                serve them in the legal profession. Our faculty members include practitioners and scholars who are
                experienced and committed to the delivery of quality education and mentorship. By emphasizing
                experiential learning, we give students the ability to engage in moot court competitions, internships
                and community service programs in which they can put theory into practice.</p>
            <p class="text-gray-600 text-justify my-2"><strong>Vision - </strong> Our vision is the become a
                distinguished
                place for legal education and practices, research, and advocacy that produce socially conscious and
                globally competent legal professionals who uphold justice and ethical governance.</p>
            <p class="text-gray-600 text-justify my-2"><strong>Mission - </strong> Providing a well-rounded legal
                education that transforms next-generation legal professionals with not only academic knowledge but with
                real-world experiences. Include them with a strong sense of fairness, ethics, and responsibility towards
                their profession and society.</p>
        </div>

        <div id="courses" class="section p-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-justify text-gray-600">
                The scope of pursing law is vast and diverse. Pursuing law opens up a wide range of career
                opportunities, including becoming a Lawyer, Judge, Legal Advisor and Corporate Counsel, Legal Consultant
                or working in government agencies, nonprofit organization or international institutions. It provides a
                strong foundation for individuals to contribute to society, uphold justice and make a positive impact
                through the application of legal knowledge and expertise.
            </p>
            <!--<ul class="list-disc">
                <li class="text-gray-500 text-justify my-2">
                    Undergraduate Programs
                    <ul class="list-disc ml-6">
                        <li>LL.B (Bachelor of Laws)</li>
                        <li>BBA LL.B (Bachelor of Business Administration & Bachelor of Laws)</li>
                        <li>B.A. LL.B (Bachelor of Arts & Bachelor of Laws)</li>
                    </ul>
                </li>
                <li class="text-gray-500 text-justify my-2">
                    Postgraduate Programs
                    <ul class="list-disc ml-6">
                        <li>LL.M (Master of Laws)</li>
                    </ul>
                </li>
            </ul>-->
            <p class="text-gray-600 text-justify"><strong>Scope:</strong> The scope of pursuing a law degree is vast and
                diverse. It offers a transformative platform for students, providing them with vast career opportunities
                for personal and professional growth.</p>
            <ul class="list-disc px-5 text-gray-600">
                <li class="my-2">Opportunities to engage in legal research projects, write for reputed journals, and
                    contribute to policy analysis.
                </li>
                <li class="my-2">Studying law can lead to a variety of job options, such as working for the government,
                    nonprofits, or foreign institutions, or becoming a lawyer, judge, legal advisor, corporate counsel,
                    or consultant.
                </li>
                <li class="my-2">Through the use of legal knowledge and experience, it offers a solid basis for people
                    to uphold justice, contribute to society, and have a constructive impact.
                </li>
            </ul>
            <p class="my-2 text-gray-600 font-semibold">The ARNI School of Law ensures that the students are always
                ready to tackle real-world legal challenges with the right knowledge, confidence, and competence. Join
                our courses to shape a society where societal growth and justice are accessible for all.</p>
        </div>
        <div class="section p-4">
            <h2 class="text-xl font-bold mb-2">Programmes Offered in Law:</h2>
            <ol class="list-decimal px-5 text-gray-600">
                <li><span class="font-semibold">BA.LLB (Bachelor of Arts and Bachelor of Legislative Law)</span>
                    <ol class="alpha-list list-inside">
                        <li><span class="font-semibold">Eligibility:-</span> A student from general category must have
                            passed 12th in any steam with
                            aggregate 45 % marks and SC/ST/OBC category student with 40% marks.
                        </li>
                        <li><span class="font-semibold">Duration:-</span> 5 Years</li>
                    </ol>
                </li>
                <li><span class="font-semibold">LL.B (Bachelor of  Legislative Law)</span>
                    <ol class="alpha-list list-inside">
                        <li><span class="font-semibold">Eligibility:-</span> A student from general category must have
                            passed Bachelor’s degree in any steam with at least 45% marks and SC/ST/OBC category student
                            with 40% marks.
                        </li>
                        <li><span class="font-semibold">Duration:-</span> 3 Years</li>
                    </ol>
                </li>
                <li><span class="font-semibold"> LL.M (Master of  Legislative Law)<br>(Specialization: Constitutional Law, Criminal law, Corporate Law, Human Rights)</span>
                    <ol class="alpha-list list-inside">
                        <li><span class="font-semibold">Eligibility:-</span> A student from general category must have
                            passed Bachelor’s degree in any steam with at least 50% marks and SC/ST/OBC category student
                            with 45% marks.
                        </li>
                        <li><span class="font-semibold">Duration:-</span> 2 Years</li>
                    </ol>
                </li>
            </ol>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">LAW Disciplines & Specializations</h2>
            <div class="flex justify-center">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-6 w-full md:w-[25%]">
                    <div
                        *ngFor="let department of departments"
                        class="bg-white p-5  rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                    >
                        <div class="flex items-center mb-4">
                            <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                            <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                        </div>
                        <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                            <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                                <li *ngFor="let branch of department.branches">{{ branch }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="hod-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/hods-as-per-schools/dr-sudhir-kumar-pal-arni-school-of-law.png" alt="Dean"
                     class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Sudhir Kumar Pal
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">HOD’s Message</h2>
                <p class="text-gray-700 text-justify">
                    “If we desire respect for the law, we must first make the law respectable.” – Justice Louis D.
                    Brandeis.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Law is the foundation of a nation that helps to generate a secure environment for its people. From
                    working in a house to leading a company, law plays a pivotal role to streamline and manage things
                    effectively.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    In the legal field, the ARNI School of Law holds a unique position. Our faculty members are
                    committed educators and leaders in their professions, our graduates are well-equipped to meet the
                    demands of the workforce. Our staff and administrative experts are eager to assist our students in
                    discovering everything that law and law school have to offer and provide support on a variety of
                    significant issues.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    ARNI University is a hub for exploring critical issues on local, national, and global levels,
                    addressing major challenges such as rapid technological advances and polarization in legal and
                    political institutions. As a dean, my commitment is to help students excel in their legal education
                    and careers.
                </p>
                <p class="text-gray-700 mt-2 text-justify">All the very best for your success in life!</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Dr. Sudhir Kumar Pal</p>
                <p class="text-gray-700 mt-2 text-justify">Dean, ARNI School of Law</p>
                <p class="text-gray-700 mt-2 text-justify">ARNI University</p>
            </div>

        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--              <p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex justify-center transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>

                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-full">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('/about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                                Placed In:
                                                                <span class="text-[#00BFA5]">
                                  {{ testimonial.company }}
                                </span>
                                                            </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
                <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
            </div>
        </div>
    </div>
</section>
